export const MOBILE_APP_LINK =
  'https://partner-mobile.wildberries.ru/app/download?from=seller_landing';
